module.exports = "/_next/static/images/broadbandLabels-b0d3a674f0ab0999d7e4c762724f407a.webp";